export var SignedTokenType;
(function (SignedTokenType) {
    SignedTokenType["CLAIM_PODCAST_OWNERSHIP"] = "claim_podcast_ownership";
    SignedTokenType["RECORDING_SESSION"] = "recording_session";
    SignedTokenType["RECORDING_SESSION_MEDIA"] = "recording_session_media";
})(SignedTokenType || (SignedTokenType = {}));
